// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal___1f1PP","goto1":"goto1___2WEI6","goto2":"goto2___3A9aP"};